// lib/route.ts
export function parseSlugEid(param: string): { slug: string; id: string } {
  const p = String(param).trim();
  // Formato nuovo: {slug}--e_{id}
  let m = p.match(/^(.*)--e_([a-z0-9]+)$/i);
  if (m) {
    return { slug: m[1], id: m[2].toLowerCase() };
  }
  // Formato vecchio/alternativo: {slug}-e{id} (fallback)
  m = p.match(/^(.*)-e([a-z0-9]+)$/i);
  if (m) {
    return { slug: m[1], id: m[2].toLowerCase() };
  }
  throw new Error(`Invalid slug-eid format: ${param}. Expected {slug}--e_{id} or {slug}-e{id}`);
}

export function buildSlugEid(slug: string, id: string) {
  return `${slug}--e_${id.toLowerCase()}`;
}

/**
 * Normalizza un slug_eid al formato standard (--e_{id})
 * Gestisce sia il formato nuovo (--e_) che quello vecchio/alternativo (-e)
 */
export function normalizeSlugEid(slug_eid: string): string {
  try {
    const parsed = parseSlugEid(slug_eid);
    return buildSlugEid(parsed.slug, parsed.id);
  } catch {
    // Se non riesce a parsare, ritorna l'originale
    return slug_eid;
  }
}
